import { render, staticRenderFns } from "./associate-kpi.vue?vue&type=template&id=4068f658&scoped=true&"
import script from "./associate-kpi.vue?vue&type=script&lang=js&"
export * from "./associate-kpi.vue?vue&type=script&lang=js&"
import style0 from "./associate-kpi.vue?vue&type=style&index=0&id=4068f658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068f658",
  null
  
)

export default component.exports